import { clsx } from "clsx";
import { IconChevronDown } from "@tabler/icons-react";
import { Button } from "../../../../components/common/button";
import { Text } from "../../../../components/common/typography";

interface ProductDescriptionSectionProps {
  description?: string | null;
  expanded: boolean;
  onToggle: () => void;
}

export function ProductDescriptionSection({ description, expanded, onToggle }: ProductDescriptionSectionProps) {
  const text = description?.trim();
  if (!text) return null;

  // Show the expander only when there's enough content to bother hiding.
  const isLong = text.length > 200 || /\n\s*\n/.test(text);

  return (
    <div className="mx-auto flex w-[70%] flex-col gap-2">
      <div className="relative">
        <Text variant="bodySm" tone="body" className={clsx(!expanded && isLong && "line-clamp-2")}>
          {text}
        </Text>
        {!expanded && isLong && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-b from-transparent to-bgWhite" />
        )}
      </div>

      {isLong ? (
        <Button
          variant="underlinedGhost"
          size="sm"
          rightIcon={
            <IconChevronDown
              size={18}
              className={clsx("transition-transform duration-300", expanded && "rotate-180")}
            />
          }
          onClick={onToggle}
        >
          {expanded ? "Hide description" : "View full product description"}
        </Button>
      ) : null}
    </div>
  );
}
